(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-products"]) return;
  try {
    
/* Collection Products - Sort toggle + filter drawer trigger */
(function() {
  /* Sort dropdown toggle */
  document.addEventListener('click', function(e) {
    var sortBtn = e.target.closest('.js-toggle-sort');
    if (sortBtn) {
      var dropdown = sortBtn.nextElementSibling;
      if (!dropdown) return;
      var isHidden = dropdown.hasAttribute('hidden');
      dropdown.toggleAttribute('hidden', !isHidden);
      sortBtn.setAttribute('aria-expanded', isHidden ? 'true' : 'false');
      e.stopPropagation();
      return;
    }

    /* Close sort dropdown on outside click */
    var openDropdowns = document.querySelectorAll('.cp-sort-dropdown:not([hidden])');
    openDropdowns.forEach(function(dd) {
      if (!dd.contains(e.target)) {
        dd.setAttribute('hidden', '');
        var btn = dd.previousElementSibling;
        if (btn) btn.setAttribute('aria-expanded', 'false');
      }
    });
  });

  /* Filter drawer trigger */
  document.addEventListener('click', function(e) {
    var filterBtn = e.target.closest('.js-open-filter-drawer');
    if (filterBtn) {
      var section = filterBtn.closest('.collection-products');
      if (!section) return;
      var drawer = section.querySelector('.cp-filter-drawer details');
      if (drawer && !drawer.open) {
        drawer.setAttribute('open', '');
        /* Bind menu-drawer events */
        var menuDrawer = section.querySelector('menu-drawer');
        if (menuDrawer && typeof menuDrawer.bindEvents === 'function') {
          menuDrawer.bindEvents();
        }
      }
    }
  });

  /* Close pill group dropdowns on outside click */
  document.addEventListener('click', function(e) {
    if (!e.target.closest('.cp-pill-group')) {
      document.querySelectorAll('.cp-pill-group[open]').forEach(function(d) {
        d.removeAttribute('open');
      });
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerBounds = {};

      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      this.header.classList.add('shopify-section-header-sticky');

      this.currentScrollTop = 0;
      this.onScrollHandler = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
      } else {
        this.header.classList.remove('scrolled-past-header');
      }

      this.currentScrollTop = scrollTop;
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-custom"] && !Shopify.designMode) return;
  try {
    
/* ═══════════════════════════════════════════════════
   YUPER — PRODUCT GALLERY + INTERACTIONS
   ═══════════════════════════════════════════════════ */

(function() {
  'use strict';

  class YpProductGallery {
    constructor(sectionId) {
      this.section = document.getElementById('MainProductCustom-' + sectionId);
      if (!this.section) return;

      this.track = this.section.querySelector('.yp-gallery__track');
      this.slides = this.section.querySelectorAll('.yp-gallery__slide');
      this.thumbs = this.section.querySelectorAll('.yp-gallery__thumb');
      this.prevBtn = this.section.querySelector('.yp-gallery__arrow--prev');
      this.nextBtn = this.section.querySelector('.yp-gallery__arrow--next');
      this.counterCurrent = this.section.querySelector('.yp-gallery__counter-current');

      this.currentIndex = 0;
      this.totalSlides = this.slides.length;

      if (this.totalSlides <= 1) return;

      this.bindEvents();
      this.setupSwipe();
    }

    bindEvents() {
      if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.goTo(this.currentIndex - 1));
      if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.goTo(this.currentIndex + 1));

      this.thumbs.forEach(thumb => {
        thumb.addEventListener('click', () => {
          const idx = parseInt(thumb.dataset.index, 10);
          this.goTo(idx);
        });
      });
    }

    setupSwipe() {
      let startX = 0;
      let deltaX = 0;
      const viewport = this.track.parentElement;

      viewport.addEventListener('touchstart', (e) => {
        startX = e.touches[0].clientX;
        deltaX = 0;
      }, { passive: true });

      viewport.addEventListener('touchmove', (e) => {
        deltaX = e.touches[0].clientX - startX;
      }, { passive: true });

      viewport.addEventListener('touchend', () => {
        if (Math.abs(deltaX) > 40) {
          if (deltaX < 0) this.goTo(this.currentIndex + 1);
          else this.goTo(this.currentIndex - 1);
        }
      });
    }

    goTo(index) {
      if (index < 0) index = this.totalSlides - 1;
      if (index >= this.totalSlides) index = 0;

      this.currentIndex = index;
      this.track.style.transform = 'translateX(-' + (index * 100) + '%)';

      this.slides.forEach((s, i) => s.classList.toggle('is-active', i === index));
      this.thumbs.forEach((t, i) => {
        t.classList.toggle('is-active', i === index);
        if (i === index) t.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      });

      if (this.counterCurrent) this.counterCurrent.textContent = index + 1;
    }
  }

  /* Quantity selector */
  function initQuantity(section) {
    const minusBtn = section.querySelector('.yp-qty__btn--minus');
    const plusBtn = section.querySelector('.yp-qty__btn--plus');
    const input = section.querySelector('.yp-qty__input');
    if (!minusBtn || !plusBtn || !input) return;

    minusBtn.addEventListener('click', () => {
      const val = parseInt(input.value, 10) || 1;
      if (val > 1) input.value = val - 1;
    });

    plusBtn.addEventListener('click', () => {
      const val = parseInt(input.value, 10) || 1;
      input.value = val + 1;
    });
  }

  /* Size Guide modal */
  function initSizeGuide(section) {
    const sectionId = section.dataset.sectionId;
    const btn = document.getElementById('YpSizeGuideBtn-' + sectionId);
    const modal = document.getElementById('YpSizeModal-' + sectionId);
    if (!btn || !modal) return;

    document.body.appendChild(modal);

    const content = modal.querySelector('.yp-size-modal__content');
    const closeBtn = modal.querySelector('.yp-size-modal__close');

    btn.addEventListener('click', () => {
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    });

    function closeModal() {
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    closeBtn.addEventListener('click', closeModal);
    modal.addEventListener('click', (e) => {
      if (!content.contains(e.target)) closeModal();
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && modal.getAttribute('aria-hidden') === 'false') closeModal();
    });
  }

  /* UGC Videos modal */
  function initUgcVideos(section) {
    const sectionId = section.dataset.sectionId;
    const modal = document.getElementById('YpUgcModal-' + sectionId);
    if (!modal) return;

    document.body.appendChild(modal);

    const video = modal.querySelector('.yp-ugc-modal__video');
    const closeBtn = modal.querySelector('.yp-ugc-modal__close');
    const content = modal.querySelector('.yp-ugc-modal__content');
    const thumbs = section.querySelectorAll('.yp-ugc-videos__thumb');

    function openModal(src) {
      video.src = src;
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      video.play().catch(() => {});
    }

    function closeModal() {
      modal.setAttribute('aria-hidden', 'true');
      video.pause();
      video.removeAttribute('src');
      video.load();
      document.body.style.overflow = '';
    }

    thumbs.forEach(thumb => {
      thumb.addEventListener('click', () => {
        const url = thumb.dataset.ugcVideoUrl;
        if (url) openModal(url);
      });
    });

    closeBtn.addEventListener('click', closeModal);
    modal.addEventListener('click', (e) => {
      if (!content.contains(e.target)) closeModal();
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && modal.getAttribute('aria-hidden') === 'false') closeModal();
    });
  }

  /* Variant sync — keep hidden id + URL in sync with radios */
  function initVariantSync(section) {
    const variantSelects = section.querySelector('variant-selects');
    if (!variantSelects) return;

    const dataEl = variantSelects.querySelector('script[data-product-variants]');
    if (!dataEl) return;

    let variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!Array.isArray(variants) || !variants.length) return;

    const idInput = section.querySelector('input[name="id"].product-variant-id');
    const mainAtcBtn = section.querySelector('.yp-product__actions .yp-btn--atc');
    const mainAtcLabel = mainAtcBtn ? mainAtcBtn.querySelector('span') : null;
    const stickyBar = section.querySelector('[data-yp-sticky-atc]');
    const stickyBtn = section.querySelector('[data-sticky-atc-btn]');
    const stickyLabel = section.querySelector('[data-sticky-atc-label]');
    const stickyPriceCurrent = section.querySelector('[data-sticky-price-current]');
    const stickyPriceCompare = section.querySelector('[data-sticky-price-compare]');
    const stickySelect = section.querySelector('[data-sticky-variant-select]');

    const currencyCode = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'BRL';
    const moneyFmt = new Intl.NumberFormat(document.documentElement.lang || 'pt-BR', {
      style: 'currency',
      currency: currencyCode,
    });
    function formatMoney(cents) {
      const value = Number(cents) / 100;
      if (!isFinite(value)) return '';
      return moneyFmt.format(value);
    }

    function currentOptionValues() {
      return Array.from(variantSelects.querySelectorAll('fieldset.yp-option')).map(fs => {
        const checked = fs.querySelector('input[type="radio"]:checked');
        return checked ? checked.value : null;
      });
    }

    function findVariant(values) {
      return variants.find(v => {
        if (!v.options || v.options.length !== values.length) return false;
        return v.options.every((opt, i) => opt === values[i]);
      });
    }

    function updateUrl(variantId) {
      if (!window.history || !window.history.replaceState) return;
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variantId);
      window.history.replaceState({}, '', url.toString());
    }

    function setBtnState(btn, available) {
      if (!btn) return;
      if (available) btn.removeAttribute('disabled');
      else btn.setAttribute('disabled', '');
    }

    function sync() {
      const variant = findVariant(currentOptionValues());
      if (!variant) return;

      if (idInput) {
        idInput.value = variant.id;
        setBtnState(idInput, variant.available);
      }

      setBtnState(mainAtcBtn, variant.available);
      if (mainAtcLabel) {
        mainAtcLabel.textContent = variant.available ? 'Adicionar ao carrinho' : 'Esgotado';
      }

      setBtnState(stickyBtn, variant.available);
      if (stickyLabel) {
        stickyLabel.textContent = variant.available ? 'Adicionar' : 'Esgotado';
      }
      if (stickyPriceCurrent) {
        stickyPriceCurrent.textContent = formatMoney(variant.price);
      }
      if (stickyPriceCompare) {
        const hasDiscount = variant.compare_at_price && variant.compare_at_price > variant.price;
        if (hasDiscount) {
          stickyPriceCompare.textContent = formatMoney(variant.compare_at_price);
          stickyPriceCompare.removeAttribute('hidden');
        } else {
          stickyPriceCompare.textContent = '';
          stickyPriceCompare.setAttribute('hidden', '');
        }
      }

      if (stickySelect && String(stickySelect.value) !== String(variant.id)) {
        stickySelect.value = String(variant.id);
      }

      updateUrl(variant.id);
    }

    variantSelects.addEventListener('change', sync);

    /* Sticky select → propagate to radios so the main UI + sync stay in sync */
    if (stickySelect) {
      stickySelect.addEventListener('change', () => {
        const variant = variants.find(v => String(v.id) === String(stickySelect.value));
        if (!variant) return;

        const fieldsets = Array.from(variantSelects.querySelectorAll('fieldset.yp-option'));
        fieldsets.forEach((fs, i) => {
          const target = variant.options[i];
          const radio = fs.querySelector(`input[type="radio"][value="${CSS.escape(target)}"]`);
          if (radio && !radio.checked) {
            radio.checked = true;
            radio.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });

        /* If product has no options-as-radios (defensive), still run sync */
        if (!fieldsets.length) sync();
      });
    }

    if (stickyBar) {
      const mobileMql = window.matchMedia('(max-width: 749.98px)');
      let io = null;

      function showBar() { stickyBar.classList.add('is-visible'); }
      function hideBar() { stickyBar.classList.remove('is-visible'); }

      function setupVisibility() {
        if (io) { io.disconnect(); io = null; }
        if (mobileMql.matches) {
          showBar();
        } else if (mainAtcBtn && 'IntersectionObserver' in window) {
          io = new IntersectionObserver(([entry]) => {
            if (entry.isIntersecting) hideBar();
            else showBar();
          }, { threshold: 0, rootMargin: '0px 0px -8px 0px' });
          io.observe(mainAtcBtn);
        } else {
          hideBar();
        }
      }

      requestAnimationFrame(setupVisibility);
      mobileMql.addEventListener('change', setupVisibility);
    }
  }

  /* Init on load + section re-render */
  function init() {
    document.querySelectorAll('.yp-product').forEach(section => {
      const sectionId = section.dataset.sectionId;
      new YpProductGallery(sectionId);
      initQuantity(section);
      initSizeGuide(section);
      initUgcVideos(section);
      initVariantSync(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Shopify theme editor support */
  if (Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', (e) => {
      const section = e.target;
      if (section.classList.contains('yp-product')) {
        const sectionId = section.dataset.sectionId;
        new YpProductGallery(sectionId);
        initQuantity(section);
        initSizeGuide(section);
        initUgcVideos(section);
        initVariantSync(section);
      }
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["press-logos"] && !Shopify.designMode) return;
  try {
    
  class PressLogosMarquee extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.pl-track');
      this.inner = this.querySelector('.pl-track__inner');
      if (!this.track || !this.inner) return;

      this.speed = parseFloat(this.dataset.speed) || 25;
      this.offset = 0;
      this.paused = false;
      this.rafId = null;

      this.addEventListener('mouseenter', () => (this.paused = true));
      this.addEventListener('mouseleave', () => (this.paused = false));

      const images = this.inner.querySelectorAll('img');
      if (images.length === 0) {
        this.init();
        return;
      }

      let loaded = 0;
      const total = images.length;
      const onLoad = () => {
        loaded++;
        if (loaded >= total) this.init();
      };

      images.forEach((img) => {
        if (img.complete) {
          onLoad();
        } else {
          img.addEventListener('load', onLoad);
          img.addEventListener('error', onLoad);
        }
      });
    }

    init() {
      const wrapperWidth = this.offsetWidth;
      const innerWidth = this.inner.scrollWidth;

      if (innerWidth === 0) return;

      const copies = Math.ceil((wrapperWidth * 2) / innerWidth) + 1;

      for (let i = 0; i < copies; i++) {
        const clone = this.inner.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.querySelectorAll('a').forEach((a) => a.setAttribute('tabindex', '-1'));
        this.track.appendChild(clone);
      }

      this.singleWidth = innerWidth;
      this.pixelsPerSecond = this.singleWidth / this.speed;
      this.lastTime = null;

      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.rafId = requestAnimationFrame((t) => this.animate(t));
      }
    }

    animate(timestamp) {
      if (!this.lastTime) this.lastTime = timestamp;
      const delta = (timestamp - this.lastTime) / 1000;
      this.lastTime = timestamp;

      if (!this.paused) {
        this.offset -= this.pixelsPerSecond * delta;
        if (Math.abs(this.offset) >= this.singleWidth) {
          this.offset += this.singleWidth;
        }
        this.track.style.transform = `translateX(${this.offset}px)`;
      }

      this.rafId = requestAnimationFrame((t) => this.animate(t));
    }

    disconnectedCallback() {
      if (this.rafId) cancelAnimationFrame(this.rafId);
    }
  }

  if (!customElements.get('press-logos-marquee')) {
    customElements.define('press-logos-marquee', PressLogosMarquee);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["social-proof"] && !Shopify.designMode) return;
  try {
    
  class SocialProofCarousel extends HTMLElement {
    constructor() {
      super();
      this.activeIndex = 0;
      this.cards = [...this.querySelectorAll('.sp-card')];
      this.dots = [...this.querySelectorAll('.sp-dot')];
      this.totalCards = this.cards.length;
      this.visibleSlots = 4;

      this.prevBtn = this.querySelector('.sp-arrow--prev');
      this.nextBtn = this.querySelector('.sp-arrow--next');

      this.touchStartX = 0;
      this.touchEndX = 0;
    }

    connectedCallback() {
      if (this.totalCards === 0) return;

      this.detectSlots();
      this.updateView();
      this.bindEvents();

      this.resizeObserver = new ResizeObserver(() => {
        this.detectSlots();
        this.updateView();
      });
      this.resizeObserver.observe(this);
    }

    disconnectedCallback() {
      if (this.resizeObserver) this.resizeObserver.disconnect();
    }

    detectSlots() {
      const width = this.offsetWidth;
      this.isMobile = width <= 749;
      this.visibleSlots = this.isMobile ? this.totalCards : 4;
    }

    bindEvents() {
      this.prevBtn?.addEventListener('click', () => this.navigate(-1));
      this.nextBtn?.addEventListener('click', () => this.navigate(1));

      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          this.activeIndex = parseInt(dot.dataset.index, 10);
          this.updateView();
        });
      });

      // Click on card: toggle play/pause
      this.cards.forEach((card, cardIndex) => {
        card.addEventListener('click', () => {
          const video = card.querySelector('video');
          if (!video) return;

          if (video.paused) {
            // Pause all other videos first
            this.cards.forEach((c) => {
              const v = c.querySelector('video');
              if (v && v !== video) {
                v.pause();
                c.classList.remove('is-playing');
              }
            });
            this.playVideo(video);
            card.classList.add('is-playing');
          } else {
            video.pause();
            card.classList.remove('is-playing');
          }
        });
      });

      // Mute toggle
      this.querySelectorAll('.sp-card__mute-btn').forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.stopPropagation();
          this.toggleMute();
        });
      });

      // Touch/swipe
      this.addEventListener('touchstart', (e) => {
        this.touchStartX = e.changedTouches[0].screenX;
      }, { passive: true });

      this.addEventListener('touchend', (e) => {
        this.touchEndX = e.changedTouches[0].screenX;
        this.handleSwipe();
      }, { passive: true });

      // Keyboard navigation
      this.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') {
          e.preventDefault();
          this.navigate(-1);
        } else if (e.key === 'ArrowRight') {
          e.preventDefault();
          this.navigate(1);
        }
      });

      // Make carousel focusable for keyboard nav
      if (!this.hasAttribute('tabindex')) {
        this.setAttribute('tabindex', '0');
      }
    }

    navigate(direction) {
      this.activeIndex = ((this.activeIndex + direction) % this.totalCards + this.totalCards) % this.totalCards;
      this.updateView();
    }

    playVideo(video) {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      const card = video.closest('.sp-card');

      // Listen for pause to remove is-playing
      if (!video._pauseListenerAdded) {
        video.addEventListener('pause', () => {
          card?.classList.remove('is-playing');
        });
        video._pauseListenerAdded = true;
      }

      if (video.readyState >= 3) {
        video.play().catch(() => {});
      } else {
        const onCanPlay = () => {
          video.play().catch(() => {});
          video.removeEventListener('canplay', onCanPlay);
        };
        video.addEventListener('canplay', onCanPlay);
        if (video.preload !== 'auto') video.preload = 'auto';
        video.load();
      }
    }

    updateView() {
      // Mobile: show all cards, no featured state — CSS handles the slider
      if (this.isMobile) {
        this.cards.forEach((card) => {
          card.classList.add('is-visible');
          card.classList.remove('is-featured');
          const video = card.querySelector('video');
          if (video) video.preload = 'metadata';
        });
        this.dots.forEach((dot, i) => {
          dot.classList.toggle('is-active', i === 0);
          dot.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
        });
        return;
      }

      // Desktop: original behavior
      // Hide all cards
      this.cards.forEach((card) => {
        card.classList.remove('is-visible', 'is-featured');
        const video = card.querySelector('video');
        if (video) {
          video.pause();
          video.preload = 'none';
        }
      });

      // Show visible cards
      const slotsToShow = Math.min(this.visibleSlots, this.totalCards);
      for (let i = 0; i < slotsToShow; i++) {
        const idx = (this.activeIndex + i) % this.totalCards;
        const card = this.cards[idx];
        card.classList.add('is-visible');

        const video = card.querySelector('video');
        if (i === 0) {
          card.classList.add('is-featured');
          // Featured: preload auto for immediate streaming buffer
          if (video) video.preload = 'auto';
        } else {
          // Visible but not featured: preload metadata only
          if (video) video.preload = 'metadata';
        }
      }

      // Pre-buffer the next card (likely to become featured)
      const nextIdx = (this.activeIndex + 1) % this.totalCards;
      const nextVideo = this.cards[nextIdx]?.querySelector('video');
      if (nextVideo && nextVideo.preload !== 'auto') {
        nextVideo.preload = 'auto';
      }

      // Update dots
      this.dots.forEach((dot, i) => {
        const isActive = i === this.activeIndex;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
    }

    toggleMute() {
      const isMuted = this.dataset.muted !== 'false';
      this.dataset.muted = isMuted ? 'false' : 'true';

      this.cards.forEach((card) => {
        const video = card.querySelector('video');
        if (video) video.muted = !isMuted ? true : false;
      });

      // Update aria-labels
      const label = isMuted
        ? this.querySelector('.sp-card__mute-btn')?.closest('social-proof-carousel')?.dataset?.sectionId
        : null;
      this.querySelectorAll('.sp-card__mute-btn').forEach((btn) => {
        btn.setAttribute('aria-label', isMuted ? btn.dataset.unmute || 'Unmute' : btn.dataset.mute || 'Mute');
      });
    }

    handleSwipe() {
      const diff = this.touchStartX - this.touchEndX;
      const threshold = 50;
      if (Math.abs(diff) < threshold) return;
      this.navigate(diff > 0 ? 1 : -1);
    }
  }

  customElements.define('social-proof-carousel', SocialProofCarousel);

  } catch(e) { console.error(e); }
})();
})();
